import { render } from "./BannerSlider.vue?vue&type=template&id=1de5aa12&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"

import "@/assets/scss/_carousel.scss?vue&type=style&index=0&lang=scss"
import "./BannerSlider.vue?vue&type=style&index=1&id=1de5aa12&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de5aa12"]])

export default __exports__